export const ReportText = {
    sharedToGroup:
        'Thank you for your selection. The report is being sent to the chosen group(s) and will arrive shortly',
}

export const SettingsText = {
    themeUpdated: 'Your theme is updated',
    themeAdded: 'Your theme is added',
    reportSettingsUpdated: 'Report settings updated',
    inspectionNameFormatSaved: 'Inspection name format saved',
    pdfFilenameFormatSaved: 'PDF file name format saved',
    pdfImageCompressionSaved: 'PDF image compression settings saved',
    pdfImageCompressionReset: 'PDF image compression settings reset to defaults',
    companySaved: 'Company saved successfully',
}

export const DefaultText = {
    defaultError: 'Something went wrong',
}
